const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetch female ratio data from the external API
 */
export const getFemaleRatioData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/external-data/female-ratio`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    
    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('Error fetching female ratio data:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Format female ratio data for use in the OurImpactSection component
 */
export const formatFemaleRatioData = (apiData) => {
  if (!apiData) {
    return null;
  }

  let percentage;
  
  // Check if it's the InsightDB Value Matrix API response format
  if (apiData.responseCode === 200 && apiData.data && Array.isArray(apiData.data) && apiData.data.length > 0) {
    const femaleRatioItem = apiData.data.find(item => 
      item && (
        item.female !== undefined ||
        item.female_ratio !== undefined ||
        item.name?.toLowerCase().includes('female') ||
        item.title?.toLowerCase().includes('female') ||
        item.label?.toLowerCase().includes('women') ||
        item.key?.toLowerCase().includes('female_ratio')
      )
    );
    
    if (femaleRatioItem) {
      percentage = femaleRatioItem.female || 
                  femaleRatioItem.female_ratio || 
                  femaleRatioItem.value || 
                  femaleRatioItem.percentage || 
                  femaleRatioItem.ratio;
    } else {
      const firstItem = apiData.data[0];
      if (firstItem) {
        percentage = firstItem.female || 
                    firstItem.female_ratio || 
                    firstItem.value || 
                    firstItem.percentage;
      }
    }
  }
  // Handle fallback API response format
  else if (typeof apiData === 'object') {
    percentage = apiData.female_ratio || apiData.percentage || apiData.ratio;
  } else if (typeof apiData === 'string' || typeof apiData === 'number') {
    percentage = apiData;
  }

  // Ensure we have a valid percentage
  if (percentage === undefined || percentage === null) {
    return null;
  }

  // Format percentage string
  const percentageStr = percentage.toString();
  const formattedPercentage = percentageStr.includes('%') 
    ? percentageStr 
    : `${percentageStr}%`;

  const numericValue = typeof percentage === 'number' 
    ? percentage 
    : parseFloat(percentageStr.replace('%', ''));

  return {
    percentage: formattedPercentage,
    rawValue: numericValue,
    fallback: false
  };
};